// Context/FirstUrlContext.js
import React, { createContext, useContext, useState } from "react";

const FirstUrlContext = createContext();

export const useFirstUrl = () => {
  const context = useContext(FirstUrlContext);
  if (!context) {
    throw new Error("useFirstUrl must be used within a FirstUrlProvider");
  }
  return context;
};

export const FirstUrlProvider = ({ children }) => {
  const [firstUrl, setFirstUrl] = useState("");

  const resetFirstUrl = () => {
    setFirstUrl("");
  };

  return (
    <FirstUrlContext.Provider value={{ firstUrl, setFirstUrl, resetFirstUrl }}>
      {children}
    </FirstUrlContext.Provider>
  );
};
